import * as React from 'react';
import { findDOMNode } from 'react-dom';
import * as A11yDialog from 'a11y-dialog';

import Dropdown from '../components/dropdown';
import AdaCheckbox from '../views/ada-checkbox';

import { ICalendarReduxState } from '../classes/redux-state';
import { Dispatch, connect } from 'react-redux';
import { RawActions } from '@adage/ace-calendar';
import { IWACEvent } from '../classes/index';

interface FiltersModalExternalProps {
    showModal: boolean;
    onHideModal: () => void;
}

interface StateToProps {
    selectedItems: { [dropdownName: string]: string };
}

interface DispatchToProps {
    updateFilter: (filterKey: string, comparisonFunction: (evt: IWACEvent) => boolean) => any;
}

type FiltersModalProps = FiltersModalExternalProps & StateToProps & DispatchToProps;

class FiltersModal extends React.Component<FiltersModalProps, null> {
    private dialog: any;

    componentDidMount() {
        this.dialog = new A11yDialog(findDOMNode(this));

        this.dialog.on('hide', (dialogElement: HTMLDivElement, event: Event) => {
            this.props.onHideModal();
        });

        if (this.props.showModal) {
            this.dialog.show();
        } else {
            this.dialog.hide();
        }
    }

    componentWillReceiveProps(props: FiltersModalProps) {
        if (props.showModal) {
            this.dialog.show();
        } else {
            this.dialog.hide();
        }

        this.updateFilters();
    }

    componentWillUnmount() {
        this.dialog.destroy();
    }

    private boundOnClickClose = this.onClickClose.bind(this);

    /**
     * When the user clicks on the element to close the modal.
     * @param evt
     */
    private onClickClose(evt: React.MouseEvent<HTMLButtonElement>) {
        evt.preventDefault();
        this.props.onHideModal();
    }

    private updateFilters() {
        // The following updateFilter calls should match the "filterKey", and "propertyToCompare" values in the render function.
        this.props.updateFilter("venueName", this.boundComparisonFunc("venueName"));
        this.props.updateFilter("seriesNames", this.boundComparisonFunc("seriesNames"));
        this.props.updateFilter("productionName", this.boundComparisonFunc("productionName", "name"));
    }

    /**
     * Bind the apply function to this component.
     */
    private boundOnApply = this.onApply.bind(this);
    /**
     * When the user clicks "Apply", this function should run.
     * @param evt
     */
    private onApply(evt: React.MouseEvent<HTMLButtonElement>) {
        this.updateFilters();
        this.props.onHideModal();
    }

    private onCloseModal(evt: React.MouseEvent<HTMLButtonElement>) {
        this.props.onHideModal();
    }

    /**
     * Bind the comparison function to this component.
     */
    private boundComparisonFunc = this.comparisonFunc.bind(this);
    /**
     * Comparison function to be sent to ace-calendar module.
     * @param evt
     */
    private comparisonFunc(filterKey: string, eventProperty?: string) {
        const secondaryKey = eventProperty ? eventProperty : filterKey;

        return (evt: IWACEvent) => {
            // If there is no selected item stored in the redux state, that means the filters have been cleared.
            if (!this.props.selectedItems[filterKey] || this.props.selectedItems[filterKey].length === 0) {
                return true;
            }

            // If the event doesn't have the property set, then it should return false.
            if (!evt[secondaryKey]) {
                return false;
            }

            if (evt[secondaryKey].constructor === Array) {
                const arr: Array<string> = evt[secondaryKey];

                return arr.indexOf(this.props.selectedItems[filterKey]) > -1;
            } else {
                return evt[secondaryKey].toLowerCase() === this.props.selectedItems[filterKey].toLowerCase();
            }
        }
    }

    render() {
        return (
            <div id="x" aria-hidden="true" className="modal-wrapper cal-nav-mobile-modal">
                <div role="dialog" aria-label="Change Calendar Filters" className="modal-container">
                    <div className="modal-inner">
                        <div role="document" className="modal-content">
                            <div className="cal-nav-mobile-modal-filters">
                                <Dropdown filterKey="productionName" propertyToCompare="name" name="Performances" apiEndpoint="GetProductionsFilters" />
                                <AdaCheckbox />
                                <button type="button" onClick={this.boundOnApply} className="btn-secondary cal-nav-mobile-apply">Apply</button>
                            </div>
                        </div>
                    </div>
                    <button type="button" onClick={this.boundOnClickClose} data-a11y-dialog-hide aria-label="Close this dialog window" className="modal-close">
                        <span>Close</span>
                        <svg className="svg-icon-md">
                            <use xlinkHref="#icon-close-x" />
                        </svg>
                    </button>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: FiltersModalExternalProps) {
    return {
        updateFilter: (filterKey: string, comparisonFunction: (evt: IWACEvent) => boolean) => {
            dispatch(RawActions.updateEventFilter({ key: filterKey, filter: comparisonFunction }))
        }
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: FiltersModalExternalProps) {
    return {
        selectedItems: state.filterModel.dropdownOptions
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersModal);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/containers/filters-modal.tsx